import Button from '@ingka/button';
import * as React from 'react';
import { prefix } from 'app';
import { ListComponent } from 'components/listComponent';
import { CarouselComponent } from 'components/carouselComponent';
import { useEffect, useState } from 'react';
import { data } from './data';
import Text from "@ingka/text";
import Toggle from '@ingka/toggle';
import { PosterApi } from '@loyaltypoint/ifapi-core';
import { PosterListElement } from '@loyaltypoint/ifapi-core/dist/models';
import { useHistory } from 'react-router';
import { useIdleTimer } from 'react-idle-timer';

export const MainPage = () => {
  const [tab, setTab] = useState(2)
  const [items, setItems] = useState(null as any)
  const posterApi = new PosterApi({
    basePath: process.env.REACT_APP_API_URL
  });
  let history = useHistory();

  const getWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}

  useEffect(() => {
    setItems(data)
    
    let key = getWithExpiry('login');
    
    if (key) {
      getPosters(key)
    }
    else {
      history.push("/login");
    }
  }, [])


  const getPosters = async (key) => {
    let posterResponse = await posterApi.posterListGet(key);
    let posterList = posterResponse.data.data.element as PosterListElement[];
    setItems(posterList);
  }

  const handleOnIdle = event => {
    const time = getRemainingTime()
    if (time == 0) {
      setTab(2)
    }
  }

  const { getRemainingTime } = useIdleTimer({
    timeout: parseInt(process.env.TIMEOUT),
    onIdle: handleOnIdle,
    debounce: 500
  })

  return (
    <>
      <div className="container-fluid app">
        <div className='row'>
          <div className='col-7'>
            <Text tagName="h1">
              Seria BJÖRKSTA
            </Text>
          </div>
        </div>
        <div className='row'>
          <div className='col-6 mt-1'>
            <div className='desc'>
              Rama i obraz BJÖRKSTA są sprzedawane w osobnych paczkach – każda jest cienka, lekka i łatwa do przeniesienia. Po dotarciu do domu wystarczy złożyć ramę, rozwinąć obraz i umieścić go w ramie. <br />
              Voilà! A kiedy przyjdzie czas na zmianę, ramę BJÖRKSTA łatwo zdjąć i schować.
            </div>
            
          </div>
          <div className='col-5 offset-1 pb-buttons-container'>
            <div className='pb-buttons'>
            
              <div className='ml-2'>
                <Toggle
                    iconOnly={false}
                    className="switcher"
                    buttons={[{
                        text: 'Lista'
                        },
                        {
                        text: 'Karuzela'
                        }]}
                    fluid={true}
                    activeIndex={tab-1}
                    onClick={(eventObj, index) => setTab(index+1)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
            <div className='col-12'>
                <hr />
            </div>
        </div>
      </div>
      {
        items &&
        <>
          {
            tab == 1 ?
              <ListComponent items={items} /> :
              <CarouselComponent items={items} />
          }
        </>
      }
    </>
  )
}